// Single source of truth for Side Panel width thresholds.
//
// Kept in its own dependency-free module so that both the panel itself (SidePanel.tsx)
// and the layout shell (Layout.tsx) can read the same numbers without creating an import
// cycle, and so the CSS breakpoint can never silently drift from the JS logic.

export const PANEL_SIZING = {
  defaultWidthRatio: 0.4,
  minWidth: 450,
  minVisibleMainContentRatio: 0.2,
  maxWidthRatio: 0.5,
} as const;

// The composer needs this much width before its placeholder/query text starts colliding
// with the mic, send and voice controls.
export const SIDE_PANEL_MIN_WIDTH = PANEL_SIZING.minWidth;

// Smallest container that can host the panel at its minimum width without breaking the
// "panel never exceeds maxWidthRatio of the container" rule. Below this the panel cannot
// be shown honestly, so callers must fall back to the modal instead of squeezing it in.
export const SIDE_PANEL_MIN_CONTAINER_WIDTH = Math.ceil(
  PANEL_SIZING.minWidth / PANEL_SIZING.maxWidthRatio
);

// How far past the minimum width a drag may travel before we hand off to the modal. Acts
// as hysteresis so a jittery pointer resting near the minimum doesn't flap.
export const MODAL_FALLBACK_DRAG_BUFFER = 60;
